import React, { useEffect, useState } from "react";
import CarouselAuto from "react-bootstrap/Carousel";
import "react-multi-carousel/lib/styles.css";
import Spinner from "react-bootstrap/Spinner";
import { useTranslation } from "react-i18next";

import "@detail/Pages/DetailPage/CarrouselStyle.css";
import HighlightSlideComponent from "./HighlightSlideComponent";
import {
  MULTITENANT_CONSTANTS,
  TENANT,
} from "../../../../../app/src/Resources/Multitenant/tenantConstants";
import { SWITCHER_WIDTH } from "../../../../../app/src/Utils/Constants";
import { CustomNextIcon, CustomPrevIcon } from "./ArrowButtons";
import useMouseDragCarousel from "./useMouseDragCarousel";

const HighlightWidgetComponent = ({
  playlist,
  rotateTime,
  setRef,
  getRef,
  defaultBanner,
  trigger,
  clickCallback,
  playSpinner,
}) => {
  const { t } = useTranslation();
  const [renderMobileVersion, setRenderMobileVersion] = useState(false);
  const { carouselProps, dragHandlers } = useMouseDragCarousel(playlist?.length ?? 0);

  const showIndicators = () => {
    return MULTITENANT_CONSTANTS[TENANT].showSlideHighlightIndicators;
  };
  const showControls = () => {
    return !renderMobileVersion || MULTITENANT_CONSTANTS[TENANT].showControlsHighlightedComponent;
  }
  const handleResize = () => {
    setRenderMobileVersion(window.innerWidth <= SWITCHER_WIDTH);
  };

  useEffect(() => {
    handleResize();
    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  return (
    <>
      <div className="CarouselContainer Principal" {...dragHandlers}>
        {!!playlist?.length && (
          <CarouselAuto
            {...carouselProps}
            controls={showControls()}
            interval={rotateTime}
            indicators={showIndicators()}
            prevIcon={<CustomPrevIcon />}
            nextIcon={<CustomNextIcon />}
            prevLabel={t("carousel.previous")}
            nextLabel={t("carousel.next")}
          >
            {playlist?.map((w) => (
              <CarouselAuto.Item key={w.id}>
                <HighlightSlideComponent
                  w={w}
                  setRef={setRef}
                  getRef={getRef}
                  defaultBanner={defaultBanner}
                  trigger={trigger}
                  clickCallback={clickCallback}
                  renderMobileVersion={renderMobileVersion}
                />
              </CarouselAuto.Item>
            ))}
          </CarouselAuto>
        )}
        {playSpinner && (
          <div className="SpinnerContainer">
            <Spinner animation="border" />
          </div>
        )}
      </div>
    </>
  );
};

export default HighlightWidgetComponent;
